'use es6';

import * as RespondentTypes from 'feedback-schema/constants/respondentTypes';
import * as SurveyTypes from 'feedback-schema/constants/surveyTypes';
import * as SurveyStages from 'feedback-schema/constants/surveyStages';
import { Record } from 'immutable';
export const EMPTY_STRING = '';
export const WEB_CHANNEL = 'WEB';
export const LegalConsentOptions = {
  IMPLICIT_CONSENT: 'CONSENT_CHECKBOX_FOR_COMMUNICATIONS_AND_SUBMIT_AS_CONSENT_TO_PROCESS',
  SEPARATE_CONSENT: 'CONSENT_CHECKBOXES_FOR_COMMUNICATIONS_AND_PROCESSING',
  LEGITIMATE_INTEREST: 'LEGITIMATE_INTEREST',
  NONE: 'NONE'
};
export const SurveyTypeEnum = {
  [SurveyTypes.NPS]: 1,
  [SurveyTypes.CSAT]: 3
};
export const Selectors = new Record({
  HOMEPAGE: 'homepage',
  FOOTER: 'footer',
  THANK_YOU: new Record({
    CONTAINER: 'thank-you',
    HEADER: 'thank-you-header',
    BODY: 'thank-you-header-body'
  })(),
  CALLOUT: 'callout-text',
  QUESTION: 'question-text',
  FOLLOW_UP: new Record({
    TEXT: 'follow-up-question-text',
    INPUT: 'follow-up-input'
  })(),
  CSAT_RATING: typeIndex => `csat-rating-${Object.keys(RespondentTypes)[typeIndex]}`,
  SUBMIT_BUTTON: 'submit-button',
  CLOSE_BUTTON: 'close-button',
  EMAIL_INPUT: 'email-input-field',
  NO_SURVEY: 'no-survey'
})();
export const Routes = Object.keys(SurveyStages).reduce((accumulator, stage) => {
  return Object.assign({}, accumulator, {
    [stage]: {
      name: stage.toLowerCase()
    }
  });
}, {});